import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { WORK_QUEUE_STAGE_LABELS, type Inspection } from '@/services/inspection.service';
import { STAGE_BADGE } from '../stage-badge';

function fmtDate(v: string | null | undefined): string {
  if (!v) return '—';
  return new Date(v).toLocaleDateString();
}

/** Condensed, at-a-glance job identity card — always visible, not collapsible. */
export function JobSummaryCard({ inspection }: { inspection: Inspection }) {
  return (
    <div className="rounded-lg border border-border bg-card px-5 py-4">
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-mono text-sm font-bold text-foreground">
          {inspection.inspectionNumber}
        </span>
        <span
          className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${STAGE_BADGE[inspection.currentStage]}`}
        >
          {WORK_QUEUE_STAGE_LABELS[inspection.currentStage]}
        </span>
        {inspection.priorityName && (
          <span className="rounded-full bg-muted px-2.5 py-0.5 text-xs text-muted-foreground">
            {inspection.priorityName}
          </span>
        )}
        <span className="ml-auto flex items-center gap-1 text-xs text-muted-foreground">
          <FontAwesomeIcon icon={faClock} className="h-3 w-3" />
          {inspection.daysWaiting}d waiting
        </span>
      </div>

      <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-3">
        <div>
          <p className="text-xs text-muted-foreground">Customer</p>
          <p className="text-sm text-foreground">{inspection.customerName ?? '—'}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Equipment</p>
          <p className="text-sm text-foreground">
            {inspection.equipmentName}
            {inspection.equipmentAssetNumber && (
              <span className="ml-1 font-mono text-xs text-muted-foreground">
                {inspection.equipmentAssetNumber}
              </span>
            )}
          </p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Engineer</p>
          <p className="text-sm text-foreground">{inspection.assignedEngineerName ?? '—'}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Received Date</p>
          <p className="text-sm text-foreground">{fmtDate(inspection.intakeReceivedAt)}</p>
        </div>
      </div>
    </div>
  );
}
